<template>
    <Button v-bind="$attrs" type="button" variant="skeleton" class="tiw__button__back">
        <ArrowIcon />
        <span>{{ useTranslate("tiw__back") }}</span>
    </Button>
</template>

<script lang="ts" setup>
import ArrowIcon from "@/ui/icons/arrow.vue";
import useTranslate from "~/tiw/hooks/useTranslate/useTranslate";

import Button from "../button.vue";
</script>

<style lang="scss" src="./backButton.scss"></style>
